var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-status"},[(_vm.status)?_c('Icon',{attrs:{"icon":_vm.statusIcon}}):_vm._e(),(_vm.date)?_c('time',{staticClass:"card-status__date"},[_vm._v(_vm._s(_vm.formatedDate(_vm.date)))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }